import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";

/*
Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry

Description:
*/
import { put, take, select, call, actionChannel } from 'redux-saga/effects';
import { buffers } from 'redux-saga';
import Immutable from 'immutable';
import { getField, getFormFields, getFormLabels, getFormLabel, getDependentElements } from '../../selectors';
import { getErrorMessage } from '../../../fields/format';
import formIsValid from './support/form-is-valid';
import getFieldKey from '../../../form/get-field-key';
import * as actions from '../actions';
import * as formActions from '../../forms/actions';
import { updateFormDependencies } from '../../form-dependencies/actions';
import validateFields from './support/validate-fields';
var handleFieldChange = /*#__PURE__*/regeneratorRuntime.mark(function handleFieldChange(payload) {
  var formId, fieldId, value, _payload$callOnChange, callOnChange, fieldKey, field, label, dataType, required, minLength, onChangeCallback, dependentElements, inputFields, fieldUpdates, startingValues, initialValues, fieldsRemapped, updates, valueChanged, onChangePayload, foundField, fieldName, errorMessage, dirty, pristine, labels, endingValues;

  return regeneratorRuntime.wrap(function handleFieldChange$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          formId = payload.formId, fieldId = payload.fieldId, value = payload.value, _payload$callOnChange = payload.callOnChange, callOnChange = _payload$callOnChange === void 0 ? true : _payload$callOnChange;
          fieldKey = getFieldKey({
            formId: formId,
            fieldId: fieldId
          });
          _context.next = 4;
          return select(getField, fieldKey);

        case 4:
          field = _context.sent;
          _context.next = 7;
          return select(getFormLabel, formId, fieldKey);

        case 7:
          label = _context.sent;
          dataType = field.dataType, required = field.required, minLength = field.minLength, onChangeCallback = field.onChangeCallback;
          _context.next = 11;
          return select(getDependentElements, formId);

        case 11:
          dependentElements = _context.sent;
          _context.next = 14;
          return select(getFormFields, field.formId);

        case 14:
          inputFields = _context.sent;
          startingValues = inputFields.reduce(function (values, field) {
            values[field.fieldId] = field.value;
            return values;
          }, {});
          initialValues = inputFields.reduce(function (values, field) {
            values[field.fieldId] = field.initialValue;
            return values;
          }, {});
          fieldsRemapped = inputFields.reduce(function (fields, field) {
            return fields.set(field.fieldId, field);
          }, Immutable.Map());

          if (onChangeCallback) {
            updates = {
              fieldId: fieldId,
              value: value,
              dataType: dataType
            };
            valueChanged = value !== field.value;
            onChangePayload = {
              updates: updates,
              fieldId: fieldId,
              value: value,
              valueChanged: valueChanged,
              changedFieldId: field.fieldId,
              fields: fieldsRemapped
            };
            foundField = false;
            fieldUpdates = (onChangeCallback(onChangePayload) || []).map(function (update) {
              var fieldKey = getFieldKey({
                formId: formId,
                fieldId: update.fieldId
              });
              var updatedField = inputFields.get(fieldKey);

              if (fieldKey === field.fieldKey) {
                foundField = true;
              }

              update.fieldKey = fieldKey;
              update.dirty = updatedField.initialValue !== update.value;
              update.pristine = updatedField.value === update.value;
              update.errorMessage = update.errorMessage || getErrorMessage({
                dataType: updatedField.dataType,
                value: updatedField.value,
                required: updatedField.required,
                minLength: updatedField.minLength,
                fieldName: update.label || update.labelErrorMsgOverride
              });
              update.showError = !!update.errorMessage && field.fieldKey !== update.fieldKey;
              return update;
            });

            if (!foundField) {
              fieldUpdates.push({
                fieldKey: fieldKey,
                value: value,
                errorMessage: getErrorMessage({
                  dataType: dataType,
                  value: value,
                  required: required,
                  minLength: minLength
                }),
                showError: false
              });
            }
          } else {
            fieldName = label ? label.label : '';
            errorMessage = getErrorMessage({
              dataType: dataType,
              value: value,
              required: required,
              minLength: minLength,
              fieldName: fieldName
            });
            dirty = value !== initialValues[fieldId];
            pristine = value === startingValues[fieldId];
            fieldUpdates = [{
              fieldKey: fieldKey,
              fieldId: fieldId,
              formId: formId,
              value: value,
              errorMessage: errorMessage,
              showError: false,
              dirty: dirty,
              pristine: pristine
            }];
          }

          _context.next = 21;
          return put(actions.applyFieldChanges(fieldUpdates));

        case 21:
          _context.next = 23;
          return select(getFormFields, formId);

        case 23:
          inputFields = _context.sent;
          _context.next = 26;
          return select(getFormLabels, formId);

        case 26:
          labels = _context.sent;
          _context.next = 29;
          return put(actions.applyFieldChanges(validateFields({
            formId: formId,
            inputFields: inputFields,
            labels: labels,
            dependentElements: dependentElements,
            changedFieldKey: field.fieldKey
          })));

        case 29:
          _context.next = 31;
          return select(getFormFields, formId);

        case 31:
          inputFields = _context.sent;
          _context.next = 34;
          return put(formActions.changeForm({
            formId: formId,
            valid: formIsValid(inputFields)
          }));

        case 34:
          _context.next = 36;
          return put(updateFormDependencies({
            formId: formId
          }));

        case 36:
          endingValues = inputFields.reduce(function (values, field) {
            values[field.fieldId] = field.value;
            return values;
          }, {});
          callOnChange && inputFields.filter(function (field) {
            return field.onChange && startingValues[field.fieldId] !== endingValues[field.fieldId];
          }).forEach(function (field) {
            return field.onChange(endingValues[field.fieldId]);
          });

        case 38:
        case "end":
          return _context.stop();
      }
    }
  }, handleFieldChange);
});
var watchFieldChange = /*#__PURE__*/regeneratorRuntime.mark(function watchFieldChange() {
  var requestChannel, _yield$take, payload;

  return regeneratorRuntime.wrap(function watchFieldChange$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return actionChannel(actions.FIELD_CHANGE, buffers.expanding(10));

        case 2:
          requestChannel = _context2.sent;

        case 3:
          if (!true) {
            _context2.next = 12;
            break;
          }

          _context2.next = 6;
          return take(requestChannel);

        case 6:
          _yield$take = _context2.sent;
          payload = _yield$take.payload;
          _context2.next = 10;
          return call(handleFieldChange, payload);

        case 10:
          _context2.next = 3;
          break;

        case 12:
        case "end":
          return _context2.stop();
      }
    }
  }, watchFieldChange);
});
export default watchFieldChange;